import router from '@/router';

export const namespaced = true;

export const getters = {
  current: (s, g, rootState) => {
    const directoryParam = router.currentRoute.value.params.directory;
    return rootState.directories
      .find((dir) => dir.slug === directoryParam);
  },
  count: (s, g, rootState) => rootState.directories.length,
  index: (s, getter, rootState) => {
    const directory = getter.current ?? rootState.directories[0];
    const insightsName = rootState.name.toLowerCase().replace(/ /g, '-');
    return `${insightsName}_${directory.slug}`;
  },
  // eslint-disable-next-line
  primaryFilterField: (s, g) => g?.current.fields.find((f) => f.key === g.current.primary_filter.field),
  primaryFilterSettings: (s, g) => g.current.primary_filter?.settings ?? [],
};
